module.exports = __webpack_public_path__ + "static/media/leading-wellbeing-placeholder.eefab3e3.png";